// @flow
import dynamic from 'next/dynamic'

export const AudioPlayer = dynamic(import('./AudioPlayer'), { ssr: false })
